var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_mode_edit_24px",
    className: "cls-2",
    d: "M3,16.622v3.585H6.585L17.157,9.634,13.572,6.049Zm16.929-9.76a.952.952,0,0,0,0-1.348L17.692,3.277a.952.952,0,0,0-1.348,0L14.6,5.027,18.18,8.611l1.749-1.749Z",
    transform: "translate(-2.637 -2.957)",
    fill: "#09819A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.930d1433d3de0b16f6ee6c073c8cf504.svg";
export { ForwardRef as ReactComponent };